import React from 'react';
import { Title, SimpleGrid } from '@mantine/core';
import { MenuItem } from './MenuItem';
import { MenuItem as MenuItemType } from '../../types/menu';

interface MenuCategoryProps {
  category: string;
  items: MenuItemType[];
  getDisplayText: (item: MenuItemType, field: 'name' | 'description' | 'disclaimer') => string;
  onItemSelect: (itemId: string) => void;
  currentLanguage: string;
}

export const MenuCategory: React.FC<MenuCategoryProps> = React.memo(({
  category,
  items,
  getDisplayText,
  onItemSelect,
  currentLanguage,
}) => {
  return (
    <div
      id={`category-${category}`}
      data-category={category}
      data-heading={category}
      data-order="1"
      role="region"
      aria-labelledby={`category-heading-${category}`}
    >
      <Title order={3} mb="md" id={`category-heading-${category}`}>{category}</Title>
      <SimpleGrid cols={1} spacing="md">
        {items.map((item) => (
          <MenuItem
            key={item.id}
            item={item}
            getDisplayText={getDisplayText}
            onItemSelect={onItemSelect}
            currentLanguage={currentLanguage}
          />
        ))}
      </SimpleGrid>
    </div>
  );
}); 